export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "Diş hekimim “panoramik filmini çektir” dedi, ne yapmalıyım?",
    answer:
      "Diş hekiminizin istediği filmi (panoramik, 3D tomografi, sefalometrik vb.) WhatsApp'tan yazın; aynı gün uygun saat için randevunuzu oluşturalım. Çekim yaklaşık 10-15 dakika sürer, sonuç diş hekiminize dijital olarak iletilir.",
  },
  {
    question: "3D dental tomografi (CBCT) ne kadar sürer?",
    answer:
      "Çekimin kendisi ortalama 9-25 saniye sürer. Merkezdeki toplam süreniz — hazırlık, çekim ve teslim dahil — yaklaşık 10-15 dakikadır.",
  },
  {
    question: "Radyasyon dozu güvenli mi?",
    answer:
      "Modern dijital panoramik ve CBCT cihazları düşük doz protokolleriyle çalışır. Her görüntüleme kararı diş hekiminizin klinik değerlendirmesine dayanmalıdır. Hamilelik gibi özel durumlarda mutlaka hekiminize ve bize bildirin.",
  },
  {
    question: "Randevusuz gelebilir miyim?",
    answer:
      "Merkezimiz randevu ile çalışır. WhatsApp veya telefonla genellikle aynı gün için uygun saat bulunur. 0 553 730 71 30 numarasından arayabilir ya da WhatsApp'tan yazabilirsiniz.",
  },
  {
    question: "Diş hekimim film sonuçlarına nasıl ulaşır?",
    answer:
      "Görüntüler DICOM, JPG veya PNG formatında, rapor PDF olarak diş hekimlerine dijital ortamda iletilir. Aynı gün teslim hedeflenir. Kliniğiniz düzenli hasta yönlendiriyorsa özel bir iletişim hattı kurulabilir.",
  },
  {
    question: "Hangi durumda hangi film çekilir?",
    answer:
      "Panoramik: ilk muayene, çürük/kemik taraması, gömülü diş tespiti. 3D Tomografi (CBCT): implant planlaması, gömülü yirmilik diş, kist/tümör değerlendirmesi, detaylı kök kanal analizi. Sefalometrik: ortodontik tedavi (braket, şeffaf plak). TME: çene eklemi ağrısı, klik sesi, kilitlenme. Emin değilseniz WhatsApp'tan sorun, yönlendirelim.",
  },
  {
    question: "Ödeme ve fiyatlandırma nasıl?",
    answer:
      "Fiyatlar çekim türüne göre değişir. Net bilgi için WhatsApp'tan hekiminizin istediği filmi belirterek yazabilirsiniz. Nakit, banka havalesi ve kredi kartı kabul edilir.",
  },
  {
    question: "Hamilelikte röntgen çektirilebilir mi?",
    answer:
      "Hamilelikte radyolojik görüntüleme mutlaka hekiminizin onayıyla yapılmalıdır. Çekim öncesi durumu bildirin; gerekirse kurşun önlük gibi ek koruyucu önlemler alınır veya çekim ertelenir.",
  },
];